import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import PropTypes from 'prop-types';
import { memo } from 'react';

const getConfirmMessage = (label, idCount) => {
    if (idCount === 1) {
        return i18n._(t`Are you sure you want to <b>${label}</b> this item?`);
    }
    return i18n._(t`Are you sure you want to <b>${label}</b> these <b>${idCount}</b> items?`);
};

export const ConfirmDiv = memo(({ idCount, label }) => {
    const message = getConfirmMessage(label, idCount);
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: message }} />;
});

ConfirmDiv.propTypes = {
    idCount: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
};

ConfirmDiv.displayName = 'ConfirmDiv';
